// Init materialize js
//M.AutoInit(); // uncomment to initialize all materialize components without options

var rootElement = document.documentElement;

function scrollToTop() {
    rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
    })
}

// Dropdown init
document.addEventListener('DOMContentLoaded', function () {

    //sidenav
    var sidenavElems = document.querySelectorAll('.sidenav');
    var instances = M.Sidenav.init(sidenavElems, {});
    //initialize form fields
    M.updateTextFields();
    // initialize collapsible (accordions)
    var collapsibleElems = document.querySelectorAll('.collapsible');
    var instances = M.Collapsible.init(collapsibleElems, {});

    //image carousel
    var tabElems = document.querySelectorAll('.carousel');
    var instances = M.Carousel.init(tabElems, {});

    const mq = window.matchMedia("(min-width: 992px)");

    mq.addListener(WidthChange);
    WidthChange(mq);

    var callModal = document.querySelectorAll('.call-modal');
    var instances = M.Modal.init(
        callModal,
        {
            'startingTop': '50%'
        }
    );

    var ratesTabs = document.querySelectorAll('.rates-tabs');
    var instance = M.Tabs.init(ratesTabs, {});

    var newsTabs = document.querySelectorAll('.news-tabs');
    var instance = M.Tabs.init(newsTabs, {});

    var offerListTabs = document.querySelectorAll('.offer-list-tabs');
    var instance = M.Tabs.init(offerListTabs, {});

    var internationalTabs = document.querySelectorAll('.international-tabs');
    var instance = M.Tabs.init(internationalTabs, {});

    var substandardTabs = document.querySelectorAll('.substandard-tabs');
    var instance = M.Tabs.init(substandardTabs, {});

    var substandardTabs = document.querySelectorAll('.offer-content-tabs');
    var instance = M.Tabs.init(substandardTabs, {});

    var standardTabs = document.querySelectorAll('.standard-tabs');
    var instance = M.Tabs.init(standardTabs, {});

    var prefixSelect = document.querySelectorAll('#prefixselect');
    var selectInstance = M.FormSelect.init(prefixSelect, {});

    var radiusSelect = document.querySelectorAll('#radiusSelect');
    var radiusInstance = M.FormSelect.init(radiusSelect, {});

    // media query check
    function WidthChange(mq) {
        if (mq.matches) {
            // screens bigger than 993px
            // Dropdown init
            var elems = document.querySelectorAll('.dropdown-trigger');
            var instances = M.Dropdown.init(
                elems,
                {
                    'coverTrigger': false,
                    'hover': true
                }
            );
            // Dropdown init
            var elems = document.querySelectorAll('.dropdown-search-trigger');
            var instances = M.Dropdown.init(
                elems,
                {
                    'closeOnClick': false,
                    'constrainWidth': false,
                    'coverTrigger': false,
                    'hover': false
                }
            );
        } else {
            // screens smaller than 993px
            // Dropdown init
            var elems = document.querySelectorAll('.dropdown-trigger');
            var instances = M.Dropdown.init(
                elems,
                {
                    'coverTrigger': false,
                    'hover': false
                }
            );

            var langModal = document.querySelectorAll('.modal');
            var instances = M.Modal.init(
                langModal,
                {
                    'startingTop': '50%'
                }
            );

        }
    }

    window.addEventListener('load', function () {
        const swiper = new Swiper('.home-swiper', {
            // Optional parameters
            direction: 'horizontal',
            loop: true,

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            autoplay: {
                delay: 10000,
                disableOnInteraction: true,
            },
        });

        if ($('.country-destination-list-pop').length > 0) {
            jQuery.ajax({
                url: "/home/RenderOffNetCountryPopover",
            }).done(function (data, status, jqXHR) {
                var elems = document.querySelectorAll('.country-destination-list-pop');
                var instances = M.Tooltip.init(elems, {
                    html: data,
                    position: 'top',
                });
            });
        }
    });

    //Get the button:
    var scrollToTopBtn = document.getElementById("back-to-top");

    function handleScroll() {
        var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
        if ((rootElement.scrollTop / scrollTotal) > 0.50) {
            // Show button
            scrollToTopBtn.classList.add("showBtn")
        } else {
            // Hide button
            scrollToTopBtn.classList.remove("showBtn")
        }
    }

    document.addEventListener("scroll", handleScroll);
    scrollToTopBtn.addEventListener("click", scrollToTop);
});

window.addEventListener("load", (event) => {
    if (window.location.hash.length > 0) {
        //setTimeout(scrollToTop, 100)
        setTimeout(function () {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'auto'
            });
        }, 100)
    }
});
